// src/pages/Certificados.js
import React, { useState } from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { Modal, Button } from 'react-bootstrap';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '../styles/Certificados.css';

const pdfjsVersion = '3.0.279';

// URLs de los PDFs en Hostinger (ajusta si están en una subcarpeta diferente)
const pdfFiles = [
  '/1.pdf',
  '/2.pdf',
  '/3.pdf',
  '/4.pdf',
  '/5.pdf',
  '/6.pdf',
  '/7.pdf',
  '/8.pdf',
  '/9.pdf',
  '/10.pdf',
];

const Certificados = () => {
  const [show, setShow] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = (pdf) => {
    setSelectedPdf(pdf);
    setShow(true);
  };

  return (
    <div className="container mt-5 d-flex flex-column align-items-center">
      <h1 className="text-center">Certificados</h1>
      <div className="pdf-container">
        {pdfFiles.map((pdf, index) => (
          <div className="pdf-thumbnail" key={index} onClick={() => handleShow(pdf)}>
            <Worker workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjsVersion}/build/pdf.worker.min.js`}>
              <Viewer fileUrl={pdf} />
            </Worker>
          </div>
        ))}
      </div>

      <Modal show={show} onHide={handleClose} size="lg" centered dialogClassName="modal-90w">
        <Modal.Body>
          <div className="pdf-modal-content d-flex justify-content-center align-items-center">
            {selectedPdf && (
              <Worker workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjsVersion}/build/pdf.worker.min.js`}>
                <Viewer fileUrl={selectedPdf} />
              </Worker>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Certificados;
